/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.15.0
 * @since 1.0.0
 */
import { routerMiddleware } from 'connected-react-router';
import { Action, Dispatch, Middleware, MiddlewareAPI } from 'redux';

import { setAppError } from '../modules/app/appActions';
import appHistory from '../modules/app/appHistory';
import { selectApp } from '../modules/app/appSelectors';

export const routesInterceptorMiddleware: Middleware = (store: MiddlewareAPI<any>) =>
    (next: Dispatch<Action>) =>
        <A extends Action>(action: A) => {
            if (action.type === '@@router/LOCATION_CHANGE') {
                const state = store.getState();

                if (selectApp(state).hasError) {
                    // remove global app error on change location
                    store.dispatch(setAppError({ hasError: false }));
                }
            }
            next(action);
        };

export default routerMiddleware(appHistory);
